import { FACEBOOK_APP_ID } from '@/lib/consts.ts'

export default {
  install (app) {
    app.config.globalProperties.$facebook = {
      getInstance: () => {
        return new Promise((resolve, reject) => {
          window.fbAsyncInit = function () {
            window.FB.init({
              appId: FACEBOOK_APP_ID,
              status: true,
              cookie: true,
              version: 'v3.2',
            })

            window.FB.getLoginStatus(response => {
              resolve(window.FB)
            })
          }

          const id = 'facebook-sdk'
          if (document.getElementById(id)) {
            return
          }

          var fbScript = document.createElement('script')
          fbScript.setAttribute('src', '//connect.facebook.net/en_US/sdk.js')
          fbScript.setAttribute('type', 'text/javascript')
          fbScript.setAttribute('async', 'true')
          fbScript.setAttribute('id', id)

          var ref = document.getElementsByTagName('script')[0]

          ref.parentNode.insertBefore(fbScript, ref)
        })
      },
    }
  },
}
